/**
 * Which page transition a navigation gets (CSS in styles.css, `:active-view-transition-type`).
 * Only the page content moves; the sidebar and bars stay put, so the eye keeps its anchors.
 * - "section": another menu entry (/orders → /stock), the new page fades in, rising a little;
 * - "forward" / "back": deeper or shallower in the same section (list ↔ detail), a short slide
 *   in the reading direction, like a stack;
 * - "sibling": same depth in the same section (one order to the next, settings tabs), a crossfade.
 * Search-only changes (filters, tabs kept in the URL) are not page changes: no transition.
 */
export type PageTransition = "section" | "forward" | "back" | "sibling";

const segments = (pathname: string) => pathname.split("/").filter(Boolean);

export function pageTransition(from: string | undefined, to: string): PageTransition | false {
  if (from === undefined || from === to) return false;
  const a = segments(from);
  const b = segments(to);
  if (a[0] !== b[0]) return "section";
  if (b.length > a.length) return "forward";
  if (b.length < a.length) return "back";
  return "sibling";
}
